import React from 'react';
import { connect } from 'react-redux';
import Counter from '../../../shared/components/Counter';

class SeveritySliderCounter extends React.Component {
  render() {
    return <Counter severityMode value={this.props.currentSeverity * 10} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  if (state.records && state.records.current && state.records.current.record) {
    return {
      currentSeverity: state.records.current.record.severity,
    };
  }
  return {
    currentSeverity: 0,
  };
};

export default connect(mapStateToProps)(SeveritySliderCounter);
